import { Modal } from 'react-bootstrap';
import { GRAPHITE_COLOR, MAIN_BLUE_COLOR } from 'containers/App/constants';
import styled from 'styled-components';

export const SectionEditModalStyles = styled(Modal)`
  background-color: #0005;

  .modal-content {
    border: 0;
    border-radius: 8px;
    box-shadow: 0 18px 48px rgba(65, 70, 80, 0.18);
    overflow: hidden;
  }

  .modal-header {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
  }

  .modal-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.05rem;
    font-weight: 700;
  }

  .form-group {
    display: flex;
    width: 100%;

    .form-label {
      width: 30%;
    }

    .form-control {
      width: 70%;
    }

    .form-control:focus {
      border-color: ${MAIN_BLUE_COLOR};
      box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
    }
  }

  @media (max-width: 720px) {
    .form-group {
      display: block;

      .form-label,
      .form-control {
        width: 100%;
      }
    }
  }
`;
